import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=031517d0&"
import script from "./spinner.vue?vue&type=script&lang=ts&"
export * from "./spinner.vue?vue&type=script&lang=ts&"
import style0 from "./spinner.vue?vue&type=style&index=0&id=031517d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports